import React, {useMemo} from 'react';
import appConfig from '../../../app-config';
import algoliasearch from 'algoliasearch/lite';
import {InstantSearch} from 'react-instantsearch-dom';

function GlobalSearchWrapper({children}) {
  const searchClient = algoliasearch(
    'EQU97UI0M4',
    'bcae10a8e54f677ecf0c4e8966c727f4'
  );

  return appConfig.isGlobalSearchEnabled ? (
    <InstantSearch
      searchClient={searchClient}
      indexName={appConfig.algoliaIndexName}
    >
      {children}
    </InstantSearch>
  ) : (
    children
  );
}

export default GlobalSearchWrapper;
